"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distinct = void 0;
exports.inputRedundancy = inputRedundancy;
exports.whitelistCidrBlockToArray = whitelistCidrBlockToArray;
exports.edgifyVaTr101 = edgifyVaTr101;
exports.sleep = sleep;
exports.group = group;
exports.canonicalizePortConfig = canonicalizePortConfig;
exports.isVaAppliance = isVaAppliance;
exports.toVaBooleanString = toVaBooleanString;
exports.formatVaSmpte2038 = formatVaSmpte2038;
exports.pick = pick;
exports.pickNonNullish = pickNonNullish;
exports.valuesToString = valuesToString;
exports.generateRandomMacAddress = generateRandomMacAddress;
exports.execAsync = execAsync;
const canonicalize_1 = require("./canonicalize");
const util_1 = require("./util");
const child_process_1 = require("child_process");
const applianceTypeUtil_1 = require("./applianceTypeUtil");
function inputRedundancy({ ports }) {
    return ((ports && ports[0] && ports[0].copies) || 1) > 1;
}
function whitelistCidrBlockToArray(whitelistCidrBlock) {
    return whitelistCidrBlock && whitelistCidrBlock.length > 0 ? [whitelistCidrBlock].flat() : [];
}
function edgifyVaTr101(tr101) {
    return {
        prio1: {
            TS_sync_loss: tr101.prio1['1'].count,
            Sync_byte_error: tr101.prio1['2'].count,
            PAT_error: tr101.prio1['3'].count,
            Continuity_count_error: tr101.prio1['5'].count,
            PMT_error: tr101.prio1['6'].count,
            PID_error: tr101.prio1['8'].count,
        },
        prio2: {
            Transport_error: tr101.prio2['1'].count,
            CRC_error: tr101.prio2['2'].count,
            PCR_error: tr101.prio2['3'].count,
            PCR_accuracy_error: tr101.prio2['6'].count,
            PTS_error: tr101.prio2['7'].count,
            CAT_error: tr101.prio2['8'].count,
        },
    };
}
async function sleep(ms) {
    return new Promise((res) => {
        setTimeout(res, ms);
    });
}
function group(items, selector) {
    return items.reduce((acc, cur) => {
        const v = selector(cur);
        if (typeof acc[v] === 'undefined') {
            acc[v] = [];
        }
        acc[v].push(cur);
        return acc;
    }, {});
}
function canonicalizePortConfig(p) {
    return (0, canonicalize_1.canonicalize)({ ...p, meta: void 0 });
}
function isVaAppliance(appliance) {
    return (0, applianceTypeUtil_1.isVaApplianceType)(appliance.type);
}
function toVaBooleanString(b) {
    if (b) {
        return 'yes';
    }
    return 'no';
}
function formatVaSmpte2038(smpte2038) {
    const anc = Object.keys(smpte2038).reduce((acc, setting) => {
        acc[setting] = Object.keys(smpte2038[setting]).reduce((settingObj, flag) => {
            // eslint-disable-next-line no-param-reassign
            settingObj[flag] = (0, util_1.toBooleanString)(smpte2038[setting][flag]);
            return settingObj;
        }, {});
        return acc;
    }, {});
    return anc;
}
function pick(t, ...pickKeys) {
    if (!t) {
        return t;
    }
    const o = {};
    for (const k of pickKeys) {
        o[k] = t[k];
    }
    return o;
}
function pickNonNullish(t, ...pickKeys) {
    const o = {};
    for (const k of pickKeys) {
        const val = t[k];
        if (val == null) {
            continue;
        }
        o[k] = t[k];
    }
    return o;
}
function valuesToString(t) {
    const v = {};
    for (const k of Object.keys(t)) {
        v[k] = `${t[k]}`;
    }
    return v;
}
function generateRandomMacAddress() {
    return 'XX:XX:XX:XX:XX:XX'.replace(/X/g, () => Math.floor(Math.random() * 16).toString(16));
}
function maybeBufferToUtf8(b) {
    if (Buffer.isBuffer(b)) {
        return b.toString('utf8');
    }
    return b;
}
function execAsync(cmd, opts = {}) {
    return new Promise((res) => {
        (0, child_process_1.exec)(cmd, opts, (err, stdout, stderr) => {
            if (err) {
                return res([err, null]);
            }
            return res([null, { stdout: maybeBufferToUtf8(stdout), stderr: maybeBufferToUtf8(stderr) }]);
        });
    });
}
const distinct = (array, equals = (v1, v2) => v1 === v2) => {
    return array.reduce((acc, cur) => {
        if (!acc.find((v) => equals(v, cur))) {
            acc.push(cur);
        }
        return acc;
    }, []);
};
exports.distinct = distinct;
//# sourceMappingURL=data:application/json;base64,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